webpackJsonp([13],{

/***/ 62:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"breadcrumb-item":"_3lyK8OooH9BWh1wHXAdwTL","breadcrumb-last-item":"_2rO8V_yo7fat1Rv3nlfC3Z","separator":"_1Z2WQR0IcvSWaAgxtmgljU","breadcrumb":"_17ZA2aQYdxXc7mteT2QDuM _13UyNN6lRQaIE4nGDzE2-d","breadcrumb-hidden":"_1W4CorlN8AMJGoX4oKVBqr"};

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Breadcrumbs = __webpack_require__(62);
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	var _config = __webpack_require__(37);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  Breadcrumbs: {
	    displayName: 'Breadcrumbs'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Breadcrumbs/Breadcrumbs.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var Breadcrumbs = _wrapComponent('Breadcrumbs')((_dec = (0, _reactCssModules2.default)(_Breadcrumbs2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Breadcrumbs, _Component);
	
	  function Breadcrumbs() {
	    (0, _classCallCheck3.default)(this, Breadcrumbs);
	    return (0, _possibleConstructorReturn3.default)(this, (Breadcrumbs.__proto__ || (0, _getPrototypeOf2.default)(Breadcrumbs)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Breadcrumbs, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          type = _props.type,
	          trip = _props.trip,
	          localExpert = _props.localExpert,
	          inspiration = _props.inspiration,
	          customStyle = _props.customStyle;
	
	      var separator = function separator(key) {
	        return _react3.default.createElement('i', { className: 'fa fa-angle-right', styleName: 'separator', key: 'separator-' + key });
	      };
	      return _react3.default.createElement(
	        'span',
	        { styleName: 'breadcrumb', style: customStyle, itemScope: true, itemType: 'http://schema.org/BreadcrumbList' },
	        _react3.default.createElement(
	          'span',
	          { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem' },
	          _react3.default.createElement(
	            'a',
	            { itemProp: 'item', href: '/' },
	            _react3.default.createElement(
	              'span',
	              { styleName: 'breadcrumb-item', itemProp: 'name' },
	              'Home'
	            ),
	            _react3.default.createElement('meta', { itemProp: 'position', content: '1' })
	          )
	        ),
	        function () {
	          switch (type) {
	            case 'TripDetail':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'a',
	                  { itemProp: 'item', href: '/to/' + encodeURIComponent(trip.destination_location) },
	                  _react3.default.createElement(
	                    'span',
	                    { styleName: 'breadcrumb-item', itemProp: 'name' },
	                    trip.destination_location
	                  ),
	                  _react3.default.createElement('meta', { itemProp: 'position', content: '2' })
	                )
	              ), separator(2), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-2' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  trip.name
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '3' })
	              )];
	            case 'LocalExpertProfile':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  localExpert.name.first + ' ' + localExpert.name.last
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' })
	              )];
	            case 'Inspirations':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Inspiration'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/inspiration '
	                })
	              )];
	            case 'InspirationDetail':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'a',
	                  { itemProp: 'item', href: '/inspiration' },
	                  _react3.default.createElement(
	                    'span',
	                    { styleName: 'breadcrumb-item', itemProp: 'name' },
	                    'Inspiration'
	                  ),
	                  _react3.default.createElement('meta', { itemProp: 'position', content: '2' })
	                )
	              ), separator(2), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-2' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  inspiration.name
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '3' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/inspiration/' + inspiration.slug
	                })
	              )];
	            case 'Career':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Career'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/career'
	                })
	              )];
	            case 'TrustAndSafety':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Trust & Safety'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/trust-and-safety'
	                })
	              )];
	            case 'Dtac':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Dtac'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' })
	              )];
	            case 'Digi':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Digi'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/digi'
	                })
	              )];
	            case 'LocalExpertBenefits':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Local Expert Benefits'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/local-expert-benefits'
	                })
	              )];
	            case 'Sitemap':
	              return [separator(1), _react3.default.createElement(
	                'span',
	                { itemProp: 'itemListElement', itemScope: true, itemType: 'http://schema.org/ListItem', key: 'list-item-1' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'breadcrumb-last-item', itemProp: 'name' },
	                  'Sitemap'
	                ),
	                _react3.default.createElement('meta', { itemProp: 'position', content: '2' }),
	                _react3.default.createElement('meta', {
	                  itemProp: 'item',
	                  itemType: 'http://schema.org/WebPage',
	                  content: _config2.default.baseURL.en + '/sitemap'
	                })
	              )];
	            default:
	              return null;
	          }
	        }()
	      );
	    }
	  }]);
	  return Breadcrumbs;
	}(_react2.Component), _class2.propTypes = {
	  type: _react2.PropTypes.string.isRequired,
	  trip: _react2.PropTypes.object,
	  localExpert: _react2.PropTypes.object,
	  inspiration: _react2.PropTypes.object,
	  customStyle: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = Breadcrumbs;
	module.exports = exports['default'];

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(15);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(14);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(12);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(11);
	
	var _session = __webpack_require__(22);
	
	var sessionActions = _interopRequireWildcard(_session);
	
	var _trip = __webpack_require__(47);
	
	var _payment = __webpack_require__(46);
	
	var _reactRouterRedux = __webpack_require__(25);
	
	var _DefaultTrip = __webpack_require__(132);
	
	var _DefaultTrip2 = _interopRequireDefault(_DefaultTrip);
	
	var _ZHTrip = __webpack_require__(135);
	
	var _ZHTrip2 = _interopRequireDefault(_ZHTrip);
	
	var _SharedTrip = __webpack_require__(134);
	
	var _SharedTrip2 = _interopRequireDefault(_SharedTrip);
	
	var _PrivateGuideTrip = __webpack_require__(133);
	
	var _PrivateGuideTrip2 = _interopRequireDefault(_PrivateGuideTrip);
	
	var _helpers = __webpack_require__(19);
	
	var _price = __webpack_require__(60);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  Trip: {
	    displayName: 'Trip'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Trip/Trip.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var Trip = _wrapComponent('Trip')((_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    sessionData: state.session.data,
	    rates: state.info.exchangeRates,
	    isWishlisted: state.wishlist.wishlistObj.isWishlisted,
	    omitBookingFee: state.info.userConfig.omitBookingFee,
	    siteConfigs: state.info.siteConfigs,
	    tripBookNow: state.info.userConfig.tripBookNow
	  };
	}, (0, _extends3.default)({}, sessionActions, { openExternal: _trip.openExternal, clickTrip: _trip.clickTrip, impressTrip: _trip.impressTrip, loadTripDetail: _trip.load, setPaymentData: _payment.setPaymentData, push: _reactRouterRedux.push, logClickBookNow: _trip.logClickBookNow })), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Trip, _Component);
	
	  function Trip(props) {
	    (0, _classCallCheck3.default)(this, Trip);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Trip.__proto__ || (0, _getPrototypeOf2.default)(Trip)).call(this, props));
	
	    _this.impress = _this.impress.bind(_this);
	
	    if (!(typeof _this.impress === 'function')) {
	      throw new TypeError('Value of "this.impress" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.impress));
	    }
	
	    _this.click = _this.click.bind(_this);
	
	    if (!(typeof _this.click === 'function')) {
	      throw new TypeError('Value of "this.click" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.click));
	    }
	
	    _this.requestBook = _this.requestBook.bind(_this);
	
	    if (!(typeof _this.requestBook === 'function')) {
	      throw new TypeError('Value of "this.requestBook" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.requestBook));
	    }
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(Trip, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.interval = setInterval(function () {
	        var rect = _this2.refs.root.getBoundingClientRect();
	        var elemCenter = (rect.top + rect.bottom * 2) / 3;
	        if (elemCenter <= window.innerHeight && rect.bottom >= 60) {
	          _this2.impress();
	        }
	      }, 1000);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.interval) {
	        clearInterval(this.interval);
	      }
	    }
	  }, {
	    key: 'getQuantity',
	    value: function getQuantity(maxTravelers) {
	      return this.props.sessionData.quantity > maxTravelers ? maxTravelers : this.props.sessionData.quantity;
	    }
	  }, {
	    key: 'impress',
	    value: function impress() {
	      if (this.interval) {
	        clearInterval(this.interval);
	        this.interval = null;
	        this.props.impressTrip(this.props.trip._id, this.props.searchSessionId, this.props.trip.ranking_algorithm, this.props.index);
	      }
	    }
	  }, {
	    key: 'click',
	    value: function click() {
	      this.props.clickTrip(this.props.trip._id, this.props.searchSessionId, this.props.trip.ranking_algorithm, this.props.index);
	      this.impress();
	      if (this.props.trip.is_external) {
	        this.props.openExternal(this.props.trip.external_url);
	      }
	    }
	  }, {
	    key: 'requestBook',
	    value: function requestBook() {
	      this.props.logClickBookNow(this.props.trip._id, this.props.searchSessionId, this.props.trip.ranking_algorithm, this.props.index);
	      this.props.push('/booking/new?trip=' + this.props.trip.slug + '&device=bookNow&requestType=book');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          trip = _props.trip,
	          sessionData = _props.sessionData,
	          rates = _props.rates,
	          omitBookingFee = _props.omitBookingFee,
	          type = _props.type,
	          tripBookNow = _props.tripBookNow;
	      var quantity = sessionData.quantity,
	          currency = sessionData.currency;
	
	      var thumbnailCurrency = this.props.currency;
	      var displayPrice = (0, _helpers.commaizeInt)((0, _price.ceil)((0, _helpers.getDisplayPrice)(quantity, trip.full_prices, omitBookingFee), thumbnailCurrency || currency, rates));
	      var displaySeasonedPrice = (0, _helpers.commaizeInt)((0, _price.ceil)((0, _helpers.getDisplaySeasonedPrice)(quantity, trip.full_prices, omitBookingFee), thumbnailCurrency || currency, rates));
	      return _react3.default.createElement(
	        'div',
	        { ref: 'root', onClick: this.click },
	        function () {
	          switch (type) {
	            case 'tour_shared':
	              return _react3.default.createElement(_SharedTrip2.default, { trip: trip, prices: { displayPrice: displayPrice, displaySeasonedPrice: displaySeasonedPrice }, currency: currency });
	            case 'tour_private':
	              return _react3.default.createElement(_PrivateGuideTrip2.default, { trip: trip, prices: { displayPrice: displayPrice, displaySeasonedPrice: displaySeasonedPrice }, currency: currency });
	            case 'zh':
	              return _react3.default.createElement(_ZHTrip2.default, { trip: trip, prices: { displayPrice: displayPrice } });
	            default:
	              return _react3.default.createElement(_DefaultTrip2.default, (0, _extends3.default)({}, _this3.props, { prices: { displayPrice: displayPrice, displaySeasonedPrice: displaySeasonedPrice }, currency: currency, thumbnailCurrency: thumbnailCurrency, tripBookNow: tripBookNow, requestBook: _this3.requestBook }));
	          }
	        }()
	      );
	    }
	  }]);
	  return Trip;
	}(_react2.Component), _class2.propTypes = {
	  tripBookNow: _react2.PropTypes.bool,
	  omitBookingFee: _react2.PropTypes.bool,
	  index: _react2.PropTypes.number,
	  type: _react2.PropTypes.string,
	  from: _react2.PropTypes.string,
	  target: _react2.PropTypes.string,
	  currency: _react2.PropTypes.string,
	  searchSessionId: _react2.PropTypes.string,
	  trip: _react2.PropTypes.object,
	  rates: _react2.PropTypes.object,
	  sessionData: _react2.PropTypes.object,
	  siteConfigs: _react2.PropTypes.object,
	  isWishlisted: _react2.PropTypes.object,
	  push: _react2.PropTypes.func,
	  clickTrip: _react2.PropTypes.func,
	  impressTrip: _react2.PropTypes.func,
	  openExternal: _react2.PropTypes.func,
	  loadTripDetail: _react2.PropTypes.func,
	  setPaymentData: _react2.PropTypes.func,
	  logClickBookNow: _react2.PropTypes.func
	}, _class2.defaultProps = {
	  target: null,
	  searchSessionId: null
	}, _temp)) || _class));
	
	exports.default = Trip;
	
	function _inspect(input, depth) {
	  var maxDepth = 4;
	  var maxKeys = 15;
	
	  if (depth === undefined) {
	    depth = 0;
	  }
	
	  depth += 1;
	
	  if (input === null) {
	    return 'null';
	  } else if (input === undefined) {
	    return 'void';
	  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
	  } else if (Array.isArray(input)) {
	    if (input.length > 0) {
	      if (depth > maxDepth) return '[...]';
	
	      var first = _inspect(input[0], depth);
	
	      if (input.every(function (item) {
	        return _inspect(item, depth) === first;
	      })) {
	        return first.trim() + '[]';
	      } else {
	        return '[' + input.slice(0, maxKeys).map(function (item) {
	          return _inspect(item, depth);
	        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	      }
	    } else {
	      return 'Array';
	    }
	  } else {
	    var keys = (0, _keys2.default)(input);
	
	    if (!keys.length) {
	      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	        return input.constructor.name;
	      } else {
	        return 'Object';
	      }
	    }
	
	    if (depth > maxDepth) return '{...}';
	    var indent = '  '.repeat(depth - 1);
	    var entries = keys.slice(0, maxKeys).map(function (key) {
	      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	    }).join('\n  ' + indent);
	
	    if (keys.length >= maxKeys) {
	      entries += '\n  ' + indent + '...';
	    }
	
	    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	    } else {
	      return '{\n  ' + indent + entries + '\n' + indent + '}';
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 124:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main-container":"S16neekU--3fHtjFUW3V4","request-box":"_1HpW-mWPnjwergIwbdFOW0","arrow-right":"nU8vUKz_bxN-G6gW1kXGq","content-container":"Fdq8T8diV3cWK4V-fbE1","trip-name":"_3wlC7iocT32wo1qKSGI0G4","all-tags":"WNMMChMfXcTJUrgb_lvcx","tag-transport":"_2hA0qQMpT6u97OpbNPxiW7 _3hNMZ7oH3iw0LhoRYKg4Be _8NfZBr7F1U7HBWP4_gM6n","tag-inclusive":"_3NIPRl0LIwh2FE5fjdZfjN tp9wLzyXfr971sR8NG67C _8NfZBr7F1U7HBWP4_gM6n","tag-pickup":"_1MirGn3SQ_9POiPwQ805J _1vNs2PB4OE3qwqCoIlPKsr _8NfZBr7F1U7HBWP4_gM6n","trip-prices":"_3uPRP9r93zqTIYFzTWZYcZ","discount-percent-container":"_3pX78LeFU10f16UBuqlyta","discount-percent":"_3JzS6Pt6w2Q0dr5_VcVvfG","price-container":"_2ldU9F0mtPQbefrPA9MgRp","discount-price":"_2UV28yBSpzZd-_NuaoPxV1","sale-price":"_1q78IWBieXDGTSMA2feobV","per-person":"_1Sipp0Hl_FwQG17D-Xa8lx"};

/***/ }),

/***/ 125:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main-container":"_2jwbwEEZ6e82LFlG-1MXrw","trip-image":"_3kqcKraaxttGgJQ3siWUvq","trip-content":"ZXD68yIZ5asmJEAPl6jVC","trip-name":"_1q3Pe400Jzrhs52HgE6GJ7","trip-prices":"EKCjWLxdGhPXXCsSIWrEi","price-container":"c7e8X_nAVX4O5Bugq6iCJ","discount-price":"nUfmkEXcwBjM6zlK5KzcP","sale-price":"_2Iy9Fxwn-K1oc1Yjp_KNZf","discount-percent-container":"_3SOt4AaXqr8xHux60ESiRo","discount-percent":"_3ois-L5bK79YC3E7u4Oqxs","per-person":"_24mu7OM70V-2pi4GknUdsw"};

/***/ }),

/***/ 126:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"trip-image":"_3f_RcmX8exEgmLnHoRTnEt","trip-content":"_3U-DfJDDm1h2cl6KOfiOqs","trip-name":"_1u0_qUyrLAezuwvUPCHriV","trip-rating-container":"_1g0wbfVBH1n2IbXWYLqw3n","trip-footer":"_15OhQEkAgraIMr5dvKiVH9","review-count":"_2E9E8abLdLQI3eMxoCVX_g","price":"_3qLgG-sCJs97CXTYhXALWa","price-price":"_3_lF2RZq__cu5Op0Gxpb5C","price-per-person":"_1pHrLEDZVwEp2B34yaUHf"};

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cefd59bdd40f7c47f23ed32f443b479f.png";

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(15);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(14);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _DefaultTrip = __webpack_require__(191);
	
	var _DefaultTrip2 = _interopRequireDefault(_DefaultTrip);
	
	var _Link = __webpack_require__(20);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _reactIntl = __webpack_require__(10);
	
	var _RatingPoint = __webpack_require__(49);
	
	var _RatingPoint2 = _interopRequireDefault(_RatingPoint);
	
	var _WishlistButton = __webpack_require__(146);
	
	var _WishlistButton2 = _interopRequireDefault(_WishlistButton);
	
	var _helpers = __webpack_require__(19);
	
	var _media = __webpack_require__(21);
	
	var _trip = __webpack_require__(38);
	
	var _helpers2 = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  Trip: {
	    displayName: 'Trip'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Trip/DefaultTrip.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var Trip = _wrapComponent('Trip')((_dec = (0, _reactCssModules2.default)(_DefaultTrip2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Trip, _Component);
	
	  function Trip(props) {
	    (0, _classCallCheck3.default)(this, Trip);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Trip.__proto__ || (0, _getPrototypeOf2.default)(Trip)).call(this, props));
	
	    _this.renderPriceMobile = _this.renderPriceMobile.bind(_this);
	
	    if (!(typeof _this.renderPriceMobile === 'function')) {
	      throw new TypeError('Value of "this.renderPriceMobile" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.renderPriceMobile));
	    }
	
	    _this.renderPriceContent = _this.renderPriceContent.bind(_this);
	
	    if (!(typeof _this.renderPriceContent === 'function')) {
	      throw new TypeError('Value of "this.renderPriceContent" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.renderPriceContent));
	    }
	
	    _this.renderTrip = _this.renderTrip.bind(_this);
	
	    if (!(typeof _this.renderTrip === 'function')) {
	      throw new TypeError('Value of "this.renderTrip" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.renderTrip));
	    }
	
	    _this.isVerified = _this.isVerified.bind(_this);
	
	    if (!(typeof _this.isVerified === 'function')) {
	      throw new TypeError('Value of "this.isVerified" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.isVerified));
	    }
	
	    _this.requestBook = _this.requestBook.bind(_this);
	
	    if (!(typeof _this.requestBook === 'function')) {
	      throw new TypeError('Value of "this.requestBook" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.requestBook));
	    }
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(Trip, [{
	    key: 'isVerified',
	    value: function isVerified() {
	      var trip = this.props.trip;
	
	      var user = trip.user_id;
	      var count = 0;
	      if (user && user.verification) {
	        if (user.verification.mobile_verified) {
	          count += 1;
	        }
	        if (user.verification.id_card_verified) {
	          count += 1;
	        }
	        if (user.verification.email_verified) {
	          count += 1;
	        }
	        if (user.verification.facebook_verified) {
	          count += 1;
	        }
	      }
	      if (count >= 2) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'requestBook',
	    value: function requestBook(e) {
	      e.preventDefault();
	      this.props.requestBook();
	    }
	  }, {
	    key: 'renderPriceMobile',
	    value: function renderPriceMobile(currency) {
	      var _props = this.props,
	          siteConfigs = _props.siteConfigs,
	          prices = _props.prices,
	          trip = _props.trip;
	
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'price-mobile-container' },
	        _react3.default.createElement(
	          'span',
	          { styleName: 'person-mobile' },
	          _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.per_person' })
	        ),
	        _react3.default.createElement(
	          'span',
	          { styleName: 'price-mobile' },
	          prices.displayPrice,
	          ' ',
	          siteConfigs.fixYuan && currency === 'CNY' ? '元' : currency
	        ),
	        trip.discount_percentage > 0 ? _react3.default.createElement(
	          'span',
	          { styleName: 'cross-price-mobile' },
	          prices.displaySeasonedPrice
	        ) : null
	      );
	    }
	  }, {
	    key: 'renderPriceContent',
	    value: function renderPriceContent(currency) {
	      var _props2 = this.props,
	          siteConfigs = _props2.siteConfigs,
	          prices = _props2.prices,
	          trip = _props2.trip;
	
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'trip-content-price' },
	        trip.discount_percentage > 0 ? _react3.default.createElement(
	          'span',
	          { styleName: 'cross-price' },
	          _react3.default.createElement(
	            'span',
	            null,
	            prices.displaySeasonedPrice,
	            ' ',
	            siteConfigs.fixYuan && currency === 'CNY' ? '元' : currency
	          )
	        ) : null,
	        _react3.default.createElement(
	          'div',
	          null,
	          _react3.default.createElement(
	            'span',
	            { styleName: 'price' },
	            prices.displayPrice,
	            ' ',
	            siteConfigs.fixYuan && currency === 'CNY' ? '元' : currency
	          ),
	          '\xA0',
	          _react3.default.createElement(
	            'span',
	            { styleName: 'person' },
	            _react3.default.createElement(_reactIntl.FormattedMessage, { id: trip.is_per_day === true ? 'trip.item.per_day' : 'trip.item.per_person' })
	          )
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'all-tags' },
	          (0, _helpers.getTripLabels)(trip).map(function (tag, index) {
	            return _react3.default.createElement(
	              'div',
	              { key: index, styleName: tag.style },
	              _react3.default.createElement('i', null),
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: tag.templateId })
	            );
	          })
	        )
	      );
	    }
	  }, {
	    key: 'renderTrip',
	    value: function renderTrip() {
	      var pinImage = __webpack_require__(168);
	      var pinImageMobile = __webpack_require__(127);
	      var defaultImage = __webpack_require__(48);
	      var _props3 = this.props,
	          trip = _props3.trip,
	          currency = _props3.currency,
	          isWishlisted = _props3.isWishlisted,
	          siteConfigs = _props3.siteConfigs,
	          disableWishlist = _props3.disableWishlist,
	          thumbnailCurrency = _props3.thumbnailCurrency,
	          tripBookNow = _props3.tripBookNow,
	          disableBookNow = _props3.disableBookNow;
	
	      var wishlisted = isWishlisted[trip._id] || { state: false, loading: false };
	      var transportation = (0, _trip.getTransportation)(trip.transportation);
	      return _react3.default.createElement(
	        'div',
	        { ref: 'root', styleName: 'trip-container', id: trip._id },
	        _react3.default.createElement(
	          'div',
	          { styleName: 'trip-picture' },
	          _react3.default.createElement('img', { src: trip.cover_image && (0, _media.path)(trip.cover_image, 'coverTripCard'), styleName: 'trip-picture-img', alt: trip.name }),
	          trip.video_url && _react3.default.createElement('div', { styleName: 'play-icon' }),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'trip-picture-shadow' },
	            _react3.default.createElement(
	              'div',
	              { styleName: 'trip-picture-shadow-flex' },
	              _react3.default.createElement(
	                'div',
	                { styleName: 'trip-picture-location-point' },
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'location' },
	                  _react3.default.createElement('img', { src: pinImage, width: '10', height: '15', alt: 'pin' }),
	                  _react3.default.createElement(
	                    'span',
	                    null,
	                    this.props.from && this.props.from !== trip.destination_location ? 'From ' + this.props.from : trip.destination_location
	                  )
	                ),
	                trip.rating > 0 && _react3.default.createElement(
	                  'div',
	                  { styleName: 'review-flex' },
	                  _react3.default.createElement(_RatingPoint2.default, { point: trip.rating }),
	                  _react3.default.createElement(
	                    'span',
	                    { styleName: 'review-count' },
	                    '(',
	                    trip.review_count,
	                    ' ',
	                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.reviews' }),
	                    ')'
	                  )
	                )
	              ),
	              _react3.default.createElement(
	                'div',
	                { styleName: 'lx-picture-mobile' },
	                !siteConfigs.tripHideLx && _react3.default.createElement(
	                  'div',
	                  { styleName: 'trip-content-lx-pic-container' },
	                  this.isVerified() && _react3.default.createElement('div', { styleName: 'verify-icon' }),
	                  _react3.default.createElement(
	                    'div',
	                    { styleName: 'trip-content-lx-pic' },
	                    _react3.default.createElement('img', { src: trip.user_id && trip.user_id.avatar_image ? (0, _media.path)(trip.user_id.avatar_image, 'avatarTripCard') : defaultImage, alt: trip.user_id && trip.user_id.name && trip.user_id.name.first + ' ' + trip.user_id.name.last })
	                  )
	                )
	              ),
	              trip.discount_percentage ? _react3.default.createElement(
	                'div',
	                { styleName: 'trip-picture-discount' },
	                _react3.default.createElement(
	                  'p',
	                  { styleName: 'discount-amount' },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.discount', values: { percent: trip.discount_percentage * 100 + '%', lineBreak: _react3.default.createElement('br', null) } })
	                )
	              ) : null,
	              _react3.default.createElement(
	                'div',
	                { styleName: 'trip-price-mobile' },
	                thumbnailCurrency ? this.renderPriceMobile(thumbnailCurrency) : this.renderPriceMobile(currency),
	                trip.discount_percentage ? _react3.default.createElement(
	                  'div',
	                  { styleName: 'price-off-mobile' },
	                  _react3.default.createElement(
	                    'p',
	                    null,
	                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.discount', values: { percent: trip.discount_percentage * 100 + '%', lineBreak: _react3.default.createElement('br', null) } })
	                  )
	                ) : null
	              )
	            )
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'mobile-bg-action' },
	            _react3.default.createElement(
	              'div',
	              null,
	              (0, _helpers2.isServiceTime)('06') && siteConfigs.instantEnabled && trip.is_instant_trip && _react3.default.createElement(
	                'div',
	                { styleName: 'tag-container' },
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'instant-tag-band' },
	                  _react3.default.createElement('i', { styleName: 'instant-tag-icon' }),
	                  _react3.default.createElement(
	                    'span',
	                    null,
	                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.available_tomorrow' })
	                  )
	                ),
	                _react3.default.createElement(
	                  'div',
	                  null,
	                  _react3.default.createElement('div', { styleName: 'instant-tag-arrow-top' }),
	                  _react3.default.createElement('div', { styleName: 'instant-tag-arrow-bottom' })
	                )
	              ),
	              trip.is_instant_confirmation && _react3.default.createElement(
	                'div',
	                { styleName: 'tag-container' },
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'instant-tag-band' },
	                  _react3.default.createElement('i', { styleName: 'instant-tag-icon' }),
	                  _react3.default.createElement(
	                    'span',
	                    null,
	                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'search.search_filter.extra_conditions.instant_booking' })
	                  )
	                ),
	                _react3.default.createElement(
	                  'div',
	                  null,
	                  _react3.default.createElement('div', { styleName: 'instant-tag-arrow-top' }),
	                  _react3.default.createElement('div', { styleName: 'instant-tag-arrow-bottom' })
	                )
	              ),
	              trip.tmt_tag && _react3.default.createElement(
	                'div',
	                { styleName: 'tag-container' },
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'tmt-tag-band' },
	                  _react3.default.createElement('i', { styleName: 'tmt-tag-icon' }),
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.exclusive' })
	                ),
	                _react3.default.createElement(
	                  'div',
	                  null,
	                  _react3.default.createElement('div', { styleName: 'tmt-tag-arrow-top' }),
	                  _react3.default.createElement('div', { styleName: 'tmt-tag-arrow-bottom' })
	                )
	              ),
	              trip.tags.some(function (s) {
	                return s.match(/_staff_pick$/);
	              }) && _react3.default.createElement(
	                'div',
	                { styleName: 'tag-container' },
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'feature-tag-band' },
	                  _react3.default.createElement('i', { styleName: 'tmt-tag-icon' }),
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.feature' })
	                ),
	                _react3.default.createElement(
	                  'div',
	                  null,
	                  _react3.default.createElement('div', { styleName: 'feature-tag-arrow-top' }),
	                  _react3.default.createElement('div', { styleName: 'feature-tag-arrow-bottom' })
	                )
	              ),
	              trip.rating > 0 && _react3.default.createElement(
	                'div',
	                { styleName: 'rating-mobile' },
	                _react3.default.createElement(_RatingPoint2.default, { point: trip.rating }),
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'review-count' },
	                  '(',
	                  trip.review_count,
	                  ')'
	                )
	              )
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'wishlist-mobile' },
	              !disableWishlist && _react3.default.createElement(_WishlistButton2.default, { active: wishlisted.state !== wishlisted.loading, tripSlug: trip.slug, tripId: trip._id })
	            )
	          )
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'trip-content' },
	          _react3.default.createElement(
	            'h3',
	            { className: 'trip-preview-name', styleName: 'trip-content-header' },
	            _react3.default.createElement(
	              'span',
	              null,
	              trip.name
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'location-mobile' },
	              _react3.default.createElement('img', { src: pinImageMobile, width: '10', height: '15', alt: 'pin' }),
	              _react3.default.createElement(
	                'span',
	                null,
	                this.props.from && this.props.from !== trip.destination_location ? 'From ' + this.props.from : trip.destination_location
	              )
	            )
	          ),
	          !siteConfigs.tripHideLx && _react3.default.createElement(
	            'div',
	            { styleName: 'trip-content-lx' },
	            _react3.default.createElement(
	              'div',
	              { styleName: 'trip-content-lx-pic-container' },
	              this.isVerified() && _react3.default.createElement('div', { styleName: 'verify-icon' }),
	              _react3.default.createElement(
	                'div',
	                { styleName: 'trip-content-lx-pic' },
	                _react3.default.createElement('img', { src: trip.user_id && trip.user_id.avatar_image ? (0, _media.path)(trip.user_id.avatar_image, 'avatarTripCard') : defaultImage, alt: trip.user_id && trip.user_id.name && trip.user_id.name.first + ' ' + trip.user_id.name.last })
	              )
	            ),
	            _react3.default.createElement(
	              'span',
	              null,
	              trip.user_id && trip.user_id.name && trip.user_id.name.first + ' ' + trip.user_id.name.last
	            )
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'content-container' },
	            _react3.default.createElement(
	              'div',
	              { styleName: 'content-row-wrapper' },
	              siteConfigs.tripHideLx && _react3.default.createElement(
	                'div',
	                { styleName: 'content-row' },
	                _react3.default.createElement('i', { styleName: 'view-icon' }),
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'content-label' },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.view' }),
	                  ': '
	                ),
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'content-value' },
	                  trip.view_count || 0
	                )
	              ),
	              _react3.default.createElement(
	                'div',
	                { styleName: 'content-row' },
	                _react3.default.createElement('i', { styleName: 'duration-icon' }),
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'content-label' },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.duration.label' }),
	                  ': '
	                ),
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'content-value' },
	                  (0, _trip.getHour)(trip.duration),
	                  ' ',
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.hour' })
	                )
	              ),
	              _react3.default.createElement(
	                'div',
	                { styleName: 'content-row' },
	                _react3.default.createElement('i', { styleName: trip.transportation === 'Public Transportation' ? 'public-transportation-icon' : 'private-car-icon' }),
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'content-label' },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.transportation.label' }),
	                  ': '
	                ),
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'content-value' },
	                  transportation.standard ? _react3.default.createElement(_reactIntl.FormattedMessage, { id: transportation.id }) : transportation.id
	                )
	              )
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'content-row-no-margin' },
	              _react3.default.createElement('i', { styleName: 'activity-icon' }),
	              _react3.default.createElement(
	                'span',
	                { styleName: 'content-label' },
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.activities.label' }),
	                ': '
	              ),
	              _react3.default.createElement(
	                'div',
	                { styleName: 'activities-values' },
	                trip.activities && trip.activities.map(function (act) {
	                  return _react3.default.createElement(
	                    'span',
	                    { styleName: 'activity', key: act },
	                    act
	                  );
	                })
	              )
	            )
	          ),
	          (0, _helpers.getTripLabels)(trip).length > 0 && _react3.default.createElement(
	            'div',
	            { styleName: 'all-tags-mobile' },
	            (0, _helpers.getTripLabels)(trip).map(function (tag, index) {
	              return _react3.default.createElement(
	                'div',
	                { key: index, styleName: tag.style },
	                _react3.default.createElement('i', null),
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: tag.templateId })
	              );
	            })
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'trip-content-action' },
	            thumbnailCurrency ? this.renderPriceContent(thumbnailCurrency) : this.renderPriceContent(currency),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'wishlist-container' },
	              !disableWishlist && _react3.default.createElement(_WishlistButton2.default, { active: wishlisted.state !== wishlisted.loading, tripSlug: trip.slug, tripId: trip._id })
	            )
	          ),
	          tripBookNow && !disableBookNow && _react3.default.createElement(
	            'div',
	            { styleName: 'trip-book-now-action' },
	            _react3.default.createElement(
	              'span',
	              { styleName: 'more-info-btn' },
	              'More Info'
	            ),
	            _react3.default.createElement(
	              'span',
	              { styleName: 'book-now-btn', onClick: this.requestBook },
	              'Book Now'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          trip = _props4.trip,
	          target = _props4.target;
	
	      if (trip.is_external) {
	        return _react3.default.createElement(
	          'a',
	          { href: trip.external_url, target: target },
	          this.renderTrip()
	        );
	      }
	      return _react3.default.createElement(
	        _Link2.default,
	        { to: '/trip/' + trip.slug, styleName: 'link', target: target },
	        this.renderTrip()
	      );
	    }
	  }]);
	  return Trip;
	}(_react2.Component), _class2.propTypes = {
	  tripBookNow: _react2.PropTypes.bool,
	  disableBookNow: _react2.PropTypes.bool,
	  disableWishlist: _react2.PropTypes.bool,
	  from: _react2.PropTypes.string,
	  target: _react2.PropTypes.string,
	  currency: _react2.PropTypes.string,
	  thumbnailCurrency: _react2.PropTypes.string,
	  trip: _react2.PropTypes.object,
	  prices: _react2.PropTypes.object,
	  siteConfigs: _react2.PropTypes.object,
	  isWishlisted: _react2.PropTypes.object,
	  requestBook: _react2.PropTypes.func
	}, _class2.defaultProps = {
	  target: null
	}, _temp)) || _class));
	
	exports.default = Trip;
	
	function _inspect(input, depth) {
	  var maxDepth = 4;
	  var maxKeys = 15;
	
	  if (depth === undefined) {
	    depth = 0;
	  }
	
	  depth += 1;
	
	  if (input === null) {
	    return 'null';
	  } else if (input === undefined) {
	    return 'void';
	  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
	  } else if (Array.isArray(input)) {
	    if (input.length > 0) {
	      if (depth > maxDepth) return '[...]';
	
	      var first = _inspect(input[0], depth);
	
	      if (input.every(function (item) {
	        return _inspect(item, depth) === first;
	      })) {
	        return first.trim() + '[]';
	      } else {
	        return '[' + input.slice(0, maxKeys).map(function (item) {
	          return _inspect(item, depth);
	        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	      }
	    } else {
	      return 'Array';
	    }
	  } else {
	    var keys = (0, _keys2.default)(input);
	
	    if (!keys.length) {
	      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	        return input.constructor.name;
	      } else {
	        return 'Object';
	      }
	    }
	
	    if (depth > maxDepth) return '{...}';
	    var indent = '  '.repeat(depth - 1);
	    var entries = keys.slice(0, maxKeys).map(function (key) {
	      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	    }).join('\n  ' + indent);
	
	    if (keys.length >= maxKeys) {
	      entries += '\n  ' + indent + '...';
	    }
	
	    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	    } else {
	      return '{\n  ' + indent + entries + '\n' + indent + '}';
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _PrivateGuideTrip = __webpack_require__(124);
	
	var _PrivateGuideTrip2 = _interopRequireDefault(_PrivateGuideTrip);
	
	var _Link = __webpack_require__(20);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _reactIntl = __webpack_require__(10);
	
	var _reactFontawesome = __webpack_require__(59);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _helpers = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  PrivateGuideTrip: {
	    displayName: 'PrivateGuideTrip'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Trip/PrivateGuideTrip.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var PrivateGuideTrip = _wrapComponent('PrivateGuideTrip')((_dec = (0, _reactCssModules2.default)(_PrivateGuideTrip2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(PrivateGuideTrip, _Component);
	
	  function PrivateGuideTrip(props) {
	    (0, _classCallCheck3.default)(this, PrivateGuideTrip);
	    return (0, _possibleConstructorReturn3.default)(this, (PrivateGuideTrip.__proto__ || (0, _getPrototypeOf2.default)(PrivateGuideTrip)).call(this, props));
	  }
	  // onClick() {
	  //   this.props.onClick();
	  // }
	
	
	  (0, _createClass3.default)(PrivateGuideTrip, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          trip = _props.trip,
	          prices = _props.prices,
	          currency = _props.currency;
	
	      return _react3.default.createElement(
	        _Link2.default,
	        { to: '/customize/' + trip.slug },
	        _react3.default.createElement(
	          'div',
	          { styleName: 'main-container' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'content-container' },
	            _react3.default.createElement(
	              'h3',
	              { styleName: 'trip-name' },
	              trip.name
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'trip-prices' },
	              trip.discount_percentage > 0 && _react3.default.createElement(
	                'div',
	                { styleName: 'discount-percent-container' },
	                _react3.default.createElement(
	                  'p',
	                  { styleName: 'discount-percent' },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.discount', values: { percent: trip.discount_percentage * 100 + '%', lineBreak: _react3.default.createElement('br', null) } })
	                )
	              ),
	              _react3.default.createElement(
	                'div',
	                { styleName: 'price-container' },
	                trip.discount_percentage > 0 && _react3.default.createElement(
	                  'span',
	                  { styleName: 'discount-price' },
	                  currency,
	                  ' ',
	                  prices.displaySeasonedPrice
	                ),
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'sale-price' },
	                  currency,
	                  ' ',
	                  prices.displayPrice
	                )
	              ),
	              _react3.default.createElement(
	                'p',
	                { styleName: 'per-person' },
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: trip.is_per_day === true ? 'trip.item.per_day' : 'trip.item.per_person' })
	              )
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'all-tags' },
	              (0, _helpers.getTripLabels)(trip).map(function (tag, index) {
	                return _react3.default.createElement(
	                  'div',
	                  { key: index, styleName: tag.style },
	                  _react3.default.createElement('i', null),
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: tag.templateId })
	                );
	              })
	            )
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'request-box' },
	            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.request' }),
	            _react3.default.createElement(
	              'span',
	              { styleName: 'arrow-right' },
	              _react3.default.createElement(_reactFontawesome2.default, { name: 'chevron-right' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return PrivateGuideTrip;
	}(_react2.Component), _class2.propTypes = {
	  trip: _react2.PropTypes.object,
	  prices: _react2.PropTypes.object,
	  currency: _react2.PropTypes.string
	}, _temp)) || _class));
	
	exports.default = PrivateGuideTrip;
	module.exports = exports['default'];

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _SharedTrip = __webpack_require__(125);
	
	var _SharedTrip2 = _interopRequireDefault(_SharedTrip);
	
	var _Link = __webpack_require__(20);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _reactIntl = __webpack_require__(10);
	
	var _RatingPoint = __webpack_require__(49);
	
	var _RatingPoint2 = _interopRequireDefault(_RatingPoint);
	
	var _media = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  SharedTrip: {
	    displayName: 'SharedTrip'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Trip/SharedTrip.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var SharedTrip = _wrapComponent('SharedTrip')((_dec = (0, _reactCssModules2.default)(_SharedTrip2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(SharedTrip, _Component);
	
	  function SharedTrip(props) {
	    (0, _classCallCheck3.default)(this, SharedTrip);
	    return (0, _possibleConstructorReturn3.default)(this, (SharedTrip.__proto__ || (0, _getPrototypeOf2.default)(SharedTrip)).call(this, props));
	  }
	  // onClick() {
	  //   this.props.onClick();
	  // }
	
	
	  (0, _createClass3.default)(SharedTrip, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          trip = _props.trip,
	          prices = _props.prices,
	          currency = _props.currency;
	
	      return _react3.default.createElement(
	        _Link2.default,
	        { to: '/trip/' + trip.slug },
	        _react3.default.createElement(
	          'div',
	          { styleName: 'main-container' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'trip-image', style: trip.cover_image && (0, _media.path)(trip.cover_image, 'coverTripCard', true) },
	            trip.user_id && trip.user_id.rating && trip.user_id.rating.average_rating > 0 && _react3.default.createElement(_RatingPoint2.default, { point: trip.user_id.rating.average_rating })
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'trip-content' },
	            _react3.default.createElement(
	              'h3',
	              { styleName: 'trip-name' },
	              trip.name
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'trip-prices' },
	              trip.discount_percentage > 0 && _react3.default.createElement(
	                'div',
	                { styleName: 'discount-percent-container' },
	                _react3.default.createElement(
	                  'p',
	                  { styleName: 'discount-percent' },
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.discount', values: { percent: trip.discount_percentage * 100 + '%', lineBreak: _react3.default.createElement('br', null) } })
	                )
	              ),
	              _react3.default.createElement(
	                'div',
	                { styleName: 'price-container' },
	                trip.discount_percentage > 0 && _react3.default.createElement(
	                  'span',
	                  { styleName: 'discount-price' },
	                  currency,
	                  ' ',
	                  prices.displaySeasonedPrice
	                ),
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'sale-price' },
	                  currency,
	                  ' ',
	                  prices.displayPrice
	                )
	              )
	            ),
	            _react3.default.createElement(
	              'p',
	              { styleName: 'per-person' },
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: trip.is_per_day === true ? 'trip.item.per_day' : 'trip.item.per_person' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return SharedTrip;
	}(_react2.Component), _class2.propTypes = {
	  trip: _react2.PropTypes.object,
	  prices: _react2.PropTypes.object,
	  currency: _react2.PropTypes.string
	}, _temp)) || _class));
	
	exports.default = SharedTrip;
	module.exports = exports['default'];

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _ZHTrip = __webpack_require__(126);
	
	var _ZHTrip2 = _interopRequireDefault(_ZHTrip);
	
	var _Link = __webpack_require__(20);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _reactIntl = __webpack_require__(10);
	
	var _RatingPoint = __webpack_require__(49);
	
	var _RatingPoint2 = _interopRequireDefault(_RatingPoint);
	
	var _media = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  ZHTrip: {
	    displayName: 'ZHTrip'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Trip/ZHTrip.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var ZHTrip = _wrapComponent('ZHTrip')((_dec = (0, _reactCssModules2.default)(_ZHTrip2.default), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(ZHTrip, _Component);
	
	  function ZHTrip() {
	    (0, _classCallCheck3.default)(this, ZHTrip);
	    return (0, _possibleConstructorReturn3.default)(this, (ZHTrip.__proto__ || (0, _getPrototypeOf2.default)(ZHTrip)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ZHTrip, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          trip = _props.trip,
	          prices = _props.prices;
	
	      return _react3.default.createElement(
	        _Link2.default,
	        { to: '/trip/' + trip.slug },
	        _react3.default.createElement(
	          'div',
	          null,
	          _react3.default.createElement('div', { styles: 'trip-image', style: trip.cover_image && (0, _media.path)(trip.cover_image, 'coverTripCard', true), styleName: 'trip-image' }),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'trip-content' },
	            _react3.default.createElement(
	              'h3',
	              { styleName: 'trip-name' },
	              trip.name
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'trip-rating-container' },
	              trip.user_id && trip.user_id.rating && trip.user_id.rating.average_rating > 0 && _react3.default.createElement(_RatingPoint2.default, { point: trip.user_id.rating.average_rating })
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'trip-footer' },
	              trip.user_id && trip.user_id.rating && trip.user_id.rating.count > 0 && _react3.default.createElement(
	                'span',
	                { styleName: 'review-count' },
	                trip.user_id.rating.count,
	                ' ',
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'lx_profile.reviews' })
	              ),
	              _react3.default.createElement(
	                'span',
	                { styleName: 'price' },
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'price-price' },
	                  prices.displayPrice,
	                  ' \u5143'
	                ),
	                _react3.default.createElement(
	                  'span',
	                  { styleName: 'price-per-person' },
	                  '/ ',
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.per_person' })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return ZHTrip;
	}(_react2.Component), _class2.propTypes = {
	  trip: _react2.PropTypes.object,
	  prices: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = ZHTrip;
	module.exports = exports['default'];

/***/ }),

/***/ 429:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main-container":"_3HBjs0wtecyJ-FwJK9bQUa","banner-wrapper":"_1DmKYZ07bosw1koSnEvYe9","banner-lucky-draw":"_1Q5vZwD0kA-Hk93o5TviGT","banner-desktop":"_36z8uOHlAzTetMzQ4Kc9r2 _13UyNN6lRQaIE4nGDzE2-d","banner-desktop-text-container":"_3DKVexGyGGxiZ6lNQxVN3O","banner-desktop-inner":"_1pHs6iW4PJflxF-b-SrqHd","banner-desktop-box":"_1WdgniksV7vZNFgyPaa7rJ","banner-mobile":"_3Y7H1QY_sSISwecihAIoN8 _3jblqlydyeJqpKzpSv89pq _3jblqlydyeJqpKzpSv89pq","banner-mobile-content":"_2Q01AclvXuoAgZkZ3JHKV-","action-container":"_20oMhQKWczzBmZFnLAQPF-","btn-digi-container":"ursslLbnqzPxby_DrBiAf","btn-digi":"d7I7eg6QkUlThqx9rUDVo","term-link":"_2zWa7HtkHeCyXVTbBN6aga","term-lucky-p":"_1seO1GJ9b1qDUpALqjR4pH","tmt-logo-container":"LFtEITJyUozPmq6FG2aV_","dtac-logo-container":"_3vhPDz8kXQ7RtoR_p_jUS7","main-section":"_1o2rPSlAeGFzpwyyU1Jti2","inner-10":"_3MdHLx1KUhyfp3Cd2kW_nV","header":"ugVtYTy6TjxWmUwRC-MVF UiOtkwjAwJvCk7RAufbT2","text-trip":"_2S6W7-lc3X8ZUbVOzF2xCg","btn-container":"_35wfUHaJ5VKk9eYRtMO_o9","btn-find-out":"_29Co8dtP1ilTLqPzlplbjs _3Wk5cRNrsz1QXizQTrQsX1 _3z4hgu4l-VC5FW-cdBc-3C","modal-header":"_1JQMRubT4mNaluLifmrDAL","modal-content":"_2gRajV99zbqAZm7ot5D46i","banner-normal-header":"_1R2hQbmDMQiAME2WBefH7E","description":"_25HDLetBdOsjFciWdYPp95","input-group":"wZ3qu3g2_eYXUOmpujUIZ","label-container":"_2a8-onBTkbV2MfC94AP4qk","checkbox-container":"IMKYoaspALbd05izFCHOa","asterisk":"_26Lmi5dKmD1H9JOxlj2Dh0","custom-input":"_2ZDsaTUNWCZKvLpgfXmUjn rHLXxVOx3RK6JEEL0S_nO","custom-input-error":"_2m3X746xuD5vJiycE_JbHn _2ZDsaTUNWCZKvLpgfXmUjn rHLXxVOx3RK6JEEL0S_nO","error":"_1nq5MbOdoOiooCQDwl359M","form-container":"_3uS787ymH5pPDhhJwwv7cV","submit-btn":"_17QuoNjLCgeEc-6vwh_ZIG _3Wk5cRNrsz1QXizQTrQsX1 _3z4hgu4l-VC5FW-cdBc-3C","submit-btn-loading":"_2pByUgAgJFlgptTSufcjw udGFO9cWSVBcN7dGnMEfN _3z4hgu4l-VC5FW-cdBc-3C","email":"_3U5knwBSOIeSkxp1UYJ8WU","bold":"_1hcJhUTibjN3QevoSPoWLU","fb-btn":"GZiUdgU9MKfL7xPg--30Y _1BKB_Z6W-qKWtmIZBHiA-t Sm8cTeZLJihaL4ZopfAEu _3z4hgu4l-VC5FW-cdBc-3C"};

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "15a8b21a695d79a0bfa552428b51221a.jpg";

/***/ }),

/***/ 1423:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "63b24dac1ef270575e04620f2dd45fbf.png";

/***/ }),

/***/ 1424:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "42f7c1017354f3f5bb7208e1b1e4d417.png";

/***/ }),

/***/ 1425:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "229fc3142eb9477aef0ebbcc74aa3058.png";

/***/ }),

/***/ 1669:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(15);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(14);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _dec3, _class, _class2, _temp;
	
	var _reactHelmet = __webpack_require__(31);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactCssModules = __webpack_require__(9);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Digi = __webpack_require__(429);
	
	var _Digi2 = _interopRequireDefault(_Digi);
	
	var _Link = __webpack_require__(20);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _reactIntl = __webpack_require__(10);
	
	var _reduxAsyncConnect = __webpack_require__(34);
	
	var _reactRedux = __webpack_require__(11);
	
	var _session = __webpack_require__(22);
	
	var _digi = __webpack_require__(323);
	
	var _FeaturedReviews = __webpack_require__(457);
	
	var _FeaturedReviews2 = _interopRequireDefault(_FeaturedReviews);
	
	var _AsSeenOn = __webpack_require__(318);
	
	var _AsSeenOn2 = _interopRequireDefault(_AsSeenOn);
	
	var _Modal = __webpack_require__(55);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _SeeInspiration = __webpack_require__(458);
	
	var _SeeInspiration2 = _interopRequireDefault(_SeeInspiration);
	
	var _AboutLocalExperts = __webpack_require__(666);
	
	var _AboutLocalExperts2 = _interopRequireDefault(_AboutLocalExperts);
	
	var _Breadcrumbs = __webpack_require__(63);
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	var _Trip = __webpack_require__(112);
	
	var _Trip2 = _interopRequireDefault(_Trip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  Digi: {
	    displayName: 'Digi'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/home/runner/work/redux-frontend/redux-frontend/src/containers/Digi/Digi.js',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	// import HomeWhatUsersSay from 'components/Home/HomeWhatUsersSay';
	// import Slider from 'react-slick';
	
	// import { isLoaded, load as loadHomeInfo } from 'redux/modules/home';
	
	// import InspirationBox from 'components/Dtac/InspirationBox';
	
	
	var Digi = _wrapComponent('Digi')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
	  promise: function promise(_ref) {
	    var _ref$store = _ref.store,
	        dispatch = _ref$store.dispatch,
	        getState = _ref$store.getState;
	
	    if (!(0, _digi.isLoaded)(getState())) {
	      return dispatch((0, _digi.load)());
	    }
	  }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	  return {
	    trips: state.digi.trips,
	    inspirations: state.digi.inspirations,
	    localExperts: state.digi.localExperts,
	    reviews: state.digi.reviews,
	    home: state.home.data,
	    locale: state.language.locale
	  };
	}, { openSignup: _session.openSignup, setSessionData: _session.setSessionData, loadSessionData: _session.loadSessionData, setOldPromo: _session.setOldPromo }), _dec3 = (0, _reactCssModules2.default)(_Digi2.default), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Digi, _Component);
	
	  function Digi(props) {
	    (0, _classCallCheck3.default)(this, Digi);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Digi.__proto__ || (0, _getPrototypeOf2.default)(Digi)).call(this, props));
	
	    _this.state = {
	      isOpenTermModal: false
	    };
	
	    _this.openSignup = _this.openSignup.bind(_this);
	
	    if (!(typeof _this.openSignup === 'function')) {
	      throw new TypeError('Value of "this.openSignup" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.openSignup));
	    }
	
	    _this.openTermModal = _this.openTermModal.bind(_this);
	
	    if (!(typeof _this.openTermModal === 'function')) {
	      throw new TypeError('Value of "this.openTermModal" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.openTermModal));
	    }
	
	    _this.closeTermModal = _this.closeTermModal.bind(_this);
	
	    if (!(typeof _this.closeTermModal === 'function')) {
	      throw new TypeError('Value of "this.closeTermModal" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.closeTermModal));
	    }
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(Digi, [{
	    key: 'openSignup',
	    value: function openSignup() {
	      // this.props.setSessionData({promo: 'DIGI40'})
	      // .then(()=> this.props.loadSessionData())
	      // .then(()=> this.props.setOldPromo());
	      this.props.setOldPromo();
	      this.props.openSignup();
	    }
	  }, {
	    key: 'openTermModal',
	    value: function openTermModal() {
	      this.setState({ isOpenTermModal: true });
	    }
	  }, {
	    key: 'closeTermModal',
	    value: function closeTermModal() {
	      this.setState({ isOpenTermModal: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // const banner1920 = require('./banner-1920.jpg');
	      // const bannerDesktop = require('./banner-desktop.jpg');
	      // const bannerMobile = require('./banner-mobile.jpg');
	
	      // const banner1920My = require('./banner-1920-my.jpg');
	      // const bannerDesktopMy = require('./banner-desktop-my.jpg');
	      // const bannerMobileMy = require('./banner-mobile-my.jpg');
	      var bannerMobile = __webpack_require__(439);
	      var bannerDesktopText = __webpack_require__(1423);
	      var digiImage = __webpack_require__(1424);
	      var tmtImage = __webpack_require__(1425);
	      // const bannerMobile2 = require('./banner-mobile2.jpg');
	      // const simImage = require('./tourist-sim.png');
	      // const hr = require('./hr.png');
	      // const {items} = this.props;
	      // const {isLoggedIn, phone} = this.props;
	      // const {trips, reviews, inspirations, locale, messages} = this.props;
	      var _props = this.props,
	          trips = _props.trips,
	          reviews = _props.reviews,
	          inspirations = _props.inspirations;
	
	      return _react3.default.createElement(
	        'div',
	        { styleName: 'main-container' },
	        _react3.default.createElement(_reactHelmet2.default, {
	          meta: [{ 'property': 'og:image', 'content': 'https://www.takemetour.com' + bannerMobile }]
	        }),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'banner-wrapper' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'banner-desktop' },
	            _react3.default.createElement(
	              'div',
	              { styleName: 'banner-desktop-inner' },
	              _react3.default.createElement(
	                'div',
	                { styleName: 'banner-desktop-box' },
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'banner-desktop-text-container' },
	                  _react3.default.createElement('img', { src: bannerDesktopText, alt: 'banner' })
	                ),
	                _react3.default.createElement(
	                  'h3',
	                  { styleName: 'banner-normal-header' },
	                  _react3.default.createElement(
	                    'span',
	                    null,
	                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.description' })
	                  )
	                ),
	                _react3.default.createElement(
	                  'div',
	                  { styleName: 'action-container' },
	                  _react3.default.createElement(
	                    'a',
	                    { styleName: 'btn-digi-container', onClick: this.openSignup },
	                    _react3.default.createElement(
	                      'div',
	                      { styleName: 'btn-digi' },
	                      'DG40'
	                    )
	                  ),
	                  _react3.default.createElement(
	                    'p',
	                    null,
	                    _react3.default.createElement(
	                      'a',
	                      { styleName: 'term-link', onClick: this.openTermModal },
	                      _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.terms_n_conditions' })
	                    )
	                  )
	                )
	              ),
	              _react3.default.createElement(
	                'div',
	                { styleName: 'tmt-logo-container' },
	                _react3.default.createElement('img', { src: tmtImage, alt: 'TakeMeTour logo' })
	              ),
	              _react3.default.createElement(
	                'div',
	                { styleName: 'dtac-logo-container' },
	                _react3.default.createElement('img', { src: digiImage, alt: 'Digi logo' })
	              )
	            )
	          ),
	          _react3.default.createElement(
	            'div',
	            { styleName: 'banner-mobile' },
	            _react3.default.createElement('img', { src: bannerMobile, alt: 'banner' }),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'banner-mobile-content' },
	              _react3.default.createElement(
	                'h3',
	                { styleName: 'banner-normal-header' },
	                _react3.default.createElement(
	                  'span',
	                  null,
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.description' })
	                )
	              ),
	              _react3.default.createElement(
	                'div',
	                { styleName: 'action-container' },
	                _react3.default.createElement(
	                  'a',
	                  { styleName: 'btn-digi-container', onClick: this.openSignup },
	                  _react3.default.createElement(
	                    'div',
	                    { styleName: 'btn-digi' },
	                    'DG40'
	                  )
	                ),
	                _react3.default.createElement(
	                  'p',
	                  null,
	                  _react3.default.createElement(
	                    'a',
	                    { styleName: 'term-link', onClick: this.openTermModal },
	                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.terms_n_conditions' })
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react3.default.createElement(
	          'div',
	          { styleName: 'inner-10' },
	          _react3.default.createElement(
	            'div',
	            { styleName: 'main-section' },
	            _react3.default.createElement(_Breadcrumbs2.default, { type: 'Digi', customStyle: { paddingTop: '10px' } }),
	            _react3.default.createElement(
	              'h2',
	              { styleName: 'header' },
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.recommended_trips' })
	            ),
	            trips.map(function (trip, index) {
	              return _react3.default.createElement(_Trip2.default, { trip: trip, key: 'digi-' + index, index: index });
	            }),
	            _react3.default.createElement(
	              'p',
	              { styleName: 'text-trip' },
	              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.interest' })
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'btn-container' },
	              _react3.default.createElement(
	                _Link2.default,
	                { to: '/to/Bangkok', styleName: 'btn-find-out' },
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.interest.button' })
	              )
	            )
	          )
	        ),
	        _react3.default.createElement(_AboutLocalExperts2.default, { bgColor: 'gray' }),
	        _react3.default.createElement(_SeeInspiration2.default, { inspirationLayouts: inspirations, showAllInspirations: false }),
	        _react3.default.createElement(_FeaturedReviews2.default, { reviews: reviews }),
	        _react3.default.createElement(_AsSeenOn2.default, null),
	        _react3.default.createElement(
	          _Modal2.default,
	          { isOpen: this.state.isOpenTermModal, id: 'digi-term', onClose: this.closeTermModal, style: { padding: '0' }, centerVertical: true },
	          _react3.default.createElement(
	            'div',
	            null,
	            _react3.default.createElement(
	              'div',
	              { styleName: 'modal-header' },
	              _react3.default.createElement(
	                'h3',
	                null,
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.terms_n_conditions' })
	              )
	            ),
	            _react3.default.createElement(
	              'div',
	              { styleName: 'modal-content' },
	              _react3.default.createElement(
	                'p',
	                null,
	                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.terms_n_conditions.description' }),
	                _react3.default.createElement('br', null),
	                _react3.default.createElement(
	                  'span',
	                  null,
	                  '     '.replace(/ /g, '\xA0'),
	                  '1. ',
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.terms_n_conditions.bullet_1' })
	                ),
	                _react3.default.createElement('br', null),
	                _react3.default.createElement(
	                  'span',
	                  null,
	                  '     '.replace(/ /g, '\xA0'),
	                  '2. ',
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.terms_n_conditions.bullet_2' })
	                ),
	                _react3.default.createElement('br', null),
	                _react3.default.createElement(
	                  'span',
	                  null,
	                  '     '.replace(/ /g, '\xA0'),
	                  '3. ',
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.terms_n_conditions.bullet_3' })
	                ),
	                _react3.default.createElement('br', null),
	                _react3.default.createElement(
	                  'span',
	                  null,
	                  '     '.replace(/ /g, '\xA0'),
	                  '4. ',
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.terms_n_conditions.bullet_4' })
	                ),
	                _react3.default.createElement('br', null),
	                _react3.default.createElement(
	                  'span',
	                  null,
	                  '     '.replace(/ /g, '\xA0'),
	                  '5. ',
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.terms_n_conditions.bullet_5' })
	                ),
	                _react3.default.createElement('br', null),
	                _react3.default.createElement(
	                  'span',
	                  null,
	                  '     '.replace(/ /g, '\xA0'),
	                  '6. ',
	                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'digi.terms_n_conditions.bullet_6' })
	                ),
	                _react3.default.createElement('br', null)
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return Digi;
	}(_react2.Component), _class2.propTypes = {
	  trips: _react2.PropTypes.array,
	  inspirations: _react2.PropTypes.array,
	  reviews: _react2.PropTypes.array,
	  localExperts: _react2.PropTypes.array,
	  openSignup: _react2.PropTypes.func,
	  setSessionData: _react2.PropTypes.func,
	  loadSessionData: _react2.PropTypes.func,
	  setOldPromo: _react2.PropTypes.func,
	  locale: _react2.PropTypes.string
	}, _temp)) || _class) || _class) || _class));
	
	exports.default = Digi;
	
	function _inspect(input, depth) {
	  var maxDepth = 4;
	  var maxKeys = 15;
	
	  if (depth === undefined) {
	    depth = 0;
	  }
	
	  depth += 1;
	
	  if (input === null) {
	    return 'null';
	  } else if (input === undefined) {
	    return 'void';
	  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
	  } else if (Array.isArray(input)) {
	    if (input.length > 0) {
	      if (depth > maxDepth) return '[...]';
	
	      var first = _inspect(input[0], depth);
	
	      if (input.every(function (item) {
	        return _inspect(item, depth) === first;
	      })) {
	        return first.trim() + '[]';
	      } else {
	        return '[' + input.slice(0, maxKeys).map(function (item) {
	          return _inspect(item, depth);
	        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	      }
	    } else {
	      return 'Array';
	    }
	  } else {
	    var keys = (0, _keys2.default)(input);
	
	    if (!keys.length) {
	      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	        return input.constructor.name;
	      } else {
	        return 'Object';
	      }
	    }
	
	    if (depth > maxDepth) return '{...}';
	    var indent = '  '.repeat(depth - 1);
	    var entries = keys.slice(0, maxKeys).map(function (key) {
	      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	    }).join('\n  ' + indent);
	
	    if (keys.length >= maxKeys) {
	      entries += '\n  ' + indent + '...';
	    }
	
	    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	    } else {
	      return '{\n  ' + indent + entries + '\n' + indent + '}';
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// digi-c31cccf9ef52058705ef.js